import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { Trans } from 'react-i18next';
import { formatDate, formatDateWithTime } from '../../utils/format';
import { GridCellExpand } from './GridCellExpand';

export const renderShowCellOrDefault = (show: boolean, params: GridRenderCellParams) => {
  if (params.value && show) {
    return;
  }

  return (
    <Typography color={'text.disabled'} variant={'caption'}>
      <Trans i18nKey={'notSet'} />
    </Typography>
  );
};

export const renderCellOrDefault = (params: GridRenderCellParams) => {
  if (params.value) {
    return;
  }

  return (
    <Typography color={'text.disabled'} variant={'caption'}>
      <Trans i18nKey={'notSet'} />
    </Typography>
  );
};

export const renderDateOrDefault = (params: GridRenderCellParams) => {
  if (params.value) {
    const date = new Date(params.value);
    return formatDate(date);
  }

  return (
    <Typography color={'text.disabled'} variant={'caption'}>
      <Trans i18nKey={'notSet'} />
    </Typography>
  );
};

export function renderDateWithTimeOrDefault(params: GridRenderCellParams) {
  if (params.value) {
    const date = new Date(params.value);
    return formatDateWithTime(date);
  }

  return (
    <Typography color={'text.disabled'} variant={'caption'}>
      <Trans i18nKey={'notSet'} />
    </Typography>
  );
}

export function renderCellExpand(params: GridRenderCellParams<any, string>) {
  return <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />;
}
